import {Injectable} from '@angular/core';
import {DcpPriceRatePlansData} from '@app/model/price/dcp-price-rate-plans-data';

export const RATE_PLAN_TYPE_NEW: string = 'new';
export const RATE_PLAN_TYPE_TERMINATION: string = 'termination';
export const RATE_PLAN_GLOBAL_PREFIX: string = 'RE-';

@Injectable({
  providedIn: 'root',
})
export class DcpRatePlanService {
  public filterRatePlansByType(ratePlansData: DcpPriceRatePlansData[], type: string): DcpPriceRatePlansData[] {
    const ratePlans = ratePlansData?.filter((entry) => entry.type === type);
    if (Array.isArray(ratePlans)) {
      return ratePlans;
    }
    return [];
  }

  public selectRatePlanByCurrency(ratePlans: DcpPriceRatePlansData[], currency: string): DcpPriceRatePlansData {
    return ratePlans?.find((entry) => entry.currency === currency && this.isRatePlanValid(entry));
  }

  public selectRatePlanCurrency(
    ratePlans: DcpPriceRatePlansData[],
    defaultCurrency: string,
    currencies: string[],
    isUserLoggedIn: boolean = true
  ): string {
    if (currencies) {
      const allCurrencies = Array.from(new Set([defaultCurrency, ...currencies]));

      for (const currency of allCurrencies) {
        const ratePlan = ratePlans?.find((ratePlan) =>
          isUserLoggedIn
            ? ratePlan.currency === currency
            : ratePlan.currency === currency && ratePlan.technicalName === `${RATE_PLAN_GLOBAL_PREFIX}${currency}`
        );

        if (this.isRatePlanValid(ratePlan)) {
          return ratePlan.currency;
        }
      }
    }
    return defaultCurrency;
  }

  private isRatePlanValid(ratePlan: DcpPriceRatePlansData): boolean {
    if (ratePlan) {
      const {validFrom, validUntil} = ratePlan.group;
      return !this.isRatePlanExpired(validUntil) && this.isRatePlanBetween(validFrom, validUntil);
    }
    return false;
  }

  private isRatePlanBetween(validFrom: string, validUntil: string) {
    const now = new Date();
    return (
      (validUntil === '' && now >= new Date(validFrom)) ||
      (now >= new Date(validFrom) && now <= new Date(validUntil))
    );
  }

  private isRatePlanExpired(validUntil: string) {
    return validUntil !== '' && new Date() > new Date(validUntil);
  }
}
